var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container is-fluid"},[_c('section',{staticClass:"section headcounter"},[_c('Table',{attrs:{"table":_vm.table}}),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Popup',{attrs:{"config":_vm.eventActionPopup}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }